export function isValidCpf(value: string): boolean {
    if (!value || !/^\d{11}$/.test(value)) {
        return false;
    }

    if (/^(\d)\1{10}$/.test(value)) {
        return false;
    }

    const digits = value.split('').map(Number);

    const checkDigit = (length: number): number => {
        const sum = digits
            .slice(0, length)
            .reduce((acc, digit, index) => acc + digit * (length + 1 - index), 0);
        const remainder = (sum * 10) % 11;
        return remainder === 10 ? 0 : remainder;
    };

    return checkDigit(9) === digits[9] && checkDigit(10) === digits[10];
}

export default isValidCpf;
